import Vue from 'vue'
import App from './App'
import router from './router'
import store from './Store'

// eslint-disable-next-line
import Style from './style/site.less'

import Sidebar from './components/Sidebar.vue'
import EchoTest from './components/EchoTest.vue'
import MockEphemeralTests from './components/MockEphemeralTests.vue'
import DeviceMessageComposer from '@/components/DeviceMessageComposer'
import AceEditor from 'vue2-ace-editor'

Vue.config.productionTip = false

Vue.component('sidebar', Sidebar)
Vue.component('echo-test', EchoTest)
Vue.component('mock-ephemeral-tests', MockEphemeralTests)
Vue.component('device-message-composer', DeviceMessageComposer)
Vue.component('ace-editor', AceEditor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js